export { default } from "./RegistroClientes";
